/**
 * Upload a file to storage via the server-side proxy.
 *
 * This avoids the CORS requirement of direct browser-to-S3 presigned URL
 * uploads. The file is sent as a raw binary body to the backend, which
 * uploads it to S3 using server credentials and returns the objectPath.
 *
 * @returns objectPath — use `/api/storage${objectPath}` to serve the file.
 */
const BASE = (import.meta.env.BASE_URL ?? "/").replace(/\/$/, "");

export async function uploadFile(file: File): Promise<{ objectPath: string }> {
  const res = await fetch(`${BASE}/api/storage/upload-proxy`, {
    method: "POST",
    headers: { "Content-Type": file.type || "application/octet-stream" },
    body: file,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { error?: string }).error ?? `Upload failed (${res.status})`);
  }
  return res.json();
}

/** Convenience: upload a file and return the full serving URL. */
export async function uploadFileAndGetUrl(file: File): Promise<string> {
  const { objectPath } = await uploadFile(file);
  return `${BASE}/api/storage${objectPath}`;
}
